import { ParentState, setContextWithKey } from "@hopper-b2b/checkout";
import { parsePhoneNumber } from "@hopper-b2b/utilities";
import { assign } from "xstate";

import { getSessionInfo } from "../selectors";
import type { FlightMachineContext } from "../types";

const DEFAULT_COUNTRY_CODE = "44";

export const commonActions = {
  setInitialContactInformation: assign(
    (context: FlightMachineContext, _event) => {
      const sessionUserInfo = getSessionInfo({ context })?.userInfoResponse;
      const phoneNumber = sessionUserInfo?.mobileNumber;

      const parsedPhone = parsePhoneNumber(phoneNumber);
      const initialContactInfo = {
        countryCode: `+${parsedPhone.countryCode || DEFAULT_COUNTRY_CODE}`,
        phoneNumber: parsedPhone.nationalNumber,
        email: sessionUserInfo?.email || "",
      };

      return setContextWithKey(
        context,
        `${ParentState.contactInformation}.contactInfo`,
        initialContactInfo
      );
    }
  ),
};
